import styled, { css } from "styled-components";
import { ContentContainer as HXContentContainer, mobilePageHPadding, TextBold } from "./HXMobilePage.styles";
import { FlexColumn, FlexColumnDiv } from "./common.styles";
import { colors } from "healthex-common/colors";
import { fontWeights } from "healthex-common/weights";
import { HXTextField } from "./base.styles";
import { fontSizes } from "healthex-common/sizes";
export const ContentContainer = styled(HXContentContainer) `
    gap: 24px;
    padding: 0px ${mobilePageHPadding}px 24px ${mobilePageHPadding}px;
`;
export const RevokeConsentContentView = styled(FlexColumnDiv) `
    gap: 8px;
    flex: 1;
`;
export const RevokeConsentFooteView = styled(FlexColumnDiv) `
    padding: 24px 16px;
    gap: 16px;
    align-self: stretch;
    box-sizing: border-box;
`;
export const RevokeReasonTextField = styled(HXTextField) `
    flex: 1;
    & .MuiInputBase-root {
        height: 100%;
        align-items: flex-start;
    }

    & .MuiInputBase-input {
        height: 100%;
        overflow: auto;
    }

    & .MuiFormHelperText-root {
        margin-left: 0;
    }
`;
export const FormLabel = styled.div `
    color: ${colors.black_main};
    font-weight: ${fontWeights.BOLD};

    ${(props) => props.required &&
    css `
            &::after {
                content: "*";
                color: ${colors.tulip_main};
            }
        `}
`;
export const ThankYouTitle = styled(TextBold) `
    font-size: ${fontSizes.SUPER};
`;
export const SuccessContainer = styled(FlexColumn) `
    align-items: center;
    text-align: center;
    gap: 24px;
    flex: 1;
`;
